import type { BranchWorkSchedule } from "@/shared/types/types";

export function sortWeekDays(weekDays: BranchWorkSchedule[]) {
  let raw = structuredClone(weekDays);
  const sunday = raw.splice(
    weekDays.findIndex((d) => d.day_of_week === 0),
    weekDays.findIndex((d) => d.day_of_week === 0) + 1,
  );
  return [...raw, ...sunday];
}
